'use client';

import { c as _c } from "react/compiler-runtime";
import { type RefObject, useEffect, useState } from 'react';
export const useCalculateLines = textRef => {
  const $ = _c(5);
  const [lineCount, setLineCount] = useState(0);
  let t0;
  let t1;
  if ($[0] !== textRef) {
    t0 = () => {
      const currentTextElement = textRef?.current;
      const calculateLines = () => {
        if (!currentTextElement) {
          return;
        }
        const firstChildElement = currentTextElement.firstChild;
        if (!firstChildElement || !(firstChildElement instanceof Element)) {
          return;
        }
        const lineHeight = Number.parseInt(window.getComputedStyle(firstChildElement).lineHeight, 10);
        const height = currentTextElement.offsetHeight;
        const lines = Math.round(height / lineHeight);
        setLineCount(lines);
      };
      const resizeObserver = new ResizeObserver(calculateLines);
      calculateLines();
      if (currentTextElement) {
        resizeObserver.observe(currentTextElement);
      }
      return () => {
        resizeObserver.disconnect();
      };
    };
    t1 = [textRef];
    $[0] = textRef;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] !== lineCount) {
    t2 = {
      lineCount
    };
    $[3] = lineCount;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};